import React, { useState } from "react";
import CustomButton from "../CustomButton";
import CustomSelect from "../CustomSelect";
import ModalLayout from "../layouts/ModalLayout";
import { Link } from "react-router-dom";
import { useBranchCode } from "../../util/hooks/useBranch";
import { MONTHS } from "../../util/Constants";
import ClassSelect from "../common-input/ClassSelect";

interface Props {
  onClose?: () => void;
  onSuccess?: () => void;
}

function AttendanceReportMonthly({ onClose, onSuccess }: Props) {
  const [formData, setFormData] = useState({
    year: "2026",
    month: "JANUARY",
  });

  const branchCode = useBranchCode();

  const [selectedClassId, setSelectedClassId] = useState<number | "">("");

  const handleInputChange = (e: React.ChangeEvent<any>) => {
    const { name, value } = e.target;

    if (name === "classId") {
      setSelectedClassId(Number(value));
      return;
    }

    const finalValue = name === "year" ? value.split("-")[0] : value;
    setFormData((prev) => ({ ...prev, [name]: finalValue }));
  };

  const viewUrl = `/students-attendance-report/${branchCode}/?year=${formData.year}&month=${formData.month}&classId=${selectedClassId}`;

  return (
    <ModalLayout onClose={onClose}>
      <form className="flex flex-col gap-8 max-w-xl">
        <h3 className="text-xl font-semibold text-neutral-400">
          Download Attendance Report - Month Wise
        </h3>
        <CustomSelect
          name="year"
          label="Academic Year"
          value={formData.year}
          options={["2026", "2027", "2028"]}
          placeholder="Select academic Year"
          onChange={handleInputChange}
        />

        <CustomSelect
          name="month"
          label="Month"
          value={formData.month}
          options={MONTHS}
          placeholder="Select Month"
          onChange={handleInputChange}
        />

        <ClassSelect
          name="classId"
          label="Class"
          value={selectedClassId}
          placeholder="Select Class"
          onChange={handleInputChange}
        />

        <div className="flex justify-end gap-5">
          <CustomButton
            color="bg-neutral-200"
            text="Cancel"
            onClick={onClose}
          />
          <Link target="_blank" to={viewUrl}>
            <CustomButton
              color="bg-primary-500"
              text="View"
              disabled={!formData.year || !formData.month || !selectedClassId}
            />
          </Link>
        </div>
      </form>
    </ModalLayout>
  );
}

export default AttendanceReportMonthly;
